import React from "react";
import { AlertInfo } from "../../../common/Alert";
import { FaTrash } from "react-icons/fa";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import Empty from "../../../../assets/images/appImages/category.png";
import { useAppDispatch, useAppSelector } from "../../../../redux/hook";
import { Color } from "../../../../utils/theme";
import Swal from "sweetalert2";
import {
  CartItemType,
  decrement,
  increment,
  removeCartItem,
} from "../../../../redux/slice/useCartSlice";
import { getImage, formatCurrency } from "../../../../utils/Utils";
import { getVendeur } from "../../../HomePage/HomePage";
import { useAddOrDeleteFavoriteMutation, useGetFavoriteListQuery } from "../../../../utils/api/favories/favorie.api";



const CartItemCard = ({ cartItem }: { cartItem: CartItemType }) => {
  const Vendeur = getVendeur();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((s) => s?.user);
  const [addOrDeleteFavorite] = useAddOrDeleteFavoriteMutation();
  const { data: favoritesList } = useGetFavoriteListQuery({}, { skip: !user?.slug });

  let imgProd = "";
  if (cartItem?.produit.type === "taille_unique") {
    if (cartItem?.produit.id) {
      if (cartItem?.produit.images?.length) {
        imgProd = cartItem?.produit.images[0]?.image;
      } else {
        imgProd = "";
      }
    }
  } else {
    if (cartItem?.produit.variations?.length) {
      let variation = cartItem?.produit.variations[0];
      if (variation?.images?.length) {
        imgProd = cartItem?.produit.variations[0]?.images[0]?.image;
      } else {
        if (cartItem?.produit.images?.length) {
          imgProd = cartItem?.produit.images[0]?.image;
        } else {
          imgProd = "";
        }
      }
    }
  }

  // Vérifier si le produit est en favoris
  const isFavorite = favoritesList?.some((fav: any) => fav?.produit?.id === cartItem?.produit?.id);

  // Fonction pour ajouter/supprimer des favoris
  const handleToggleFavorite = async () => {
    if (!user?.slug) {
      Swal.fire({
        icon: "info",
        title: "Veuillez vous connecter pour ajouter un produit aux favoris.",
        iconColor: Color.themeColor,
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const favorie = favoritesList?.find((fav: any) => fav?.produit?.id === cartItem?.produit?.id);
    
    const formData = new FormData();
    formData.append("user", user.id);
    formData.append("produit", cartItem.produit.id);

    try {
      if (favorie) {
        await addOrDeleteFavorite({ slug: favorie.slug, data: formData });
      } else {
        await addOrDeleteFavorite({ data: formData });
      }
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  // Fonction pour supprimer un produit du panier
  const supprimerDuPanier = async (produitASupprimer: CartItemType) => {
    await Swal.fire({
      title: "Êtes-vous sûr(e) de vouloir supprimer ce produit de votre panier ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
      showLoaderOnConfirm: true,
      iconColor: Color.themeColor,
      confirmButtonColor: Color.success,
      preConfirm: async () => {
        return await dispatch(removeCartItem(produitASupprimer));
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result: any) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: `Produit supprimé avec succès !`,
          iconColor: Color.success,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  };

  const handleDecrement = () => {
    if (cartItem.quantite > 1) {
      dispatch(decrement(cartItem));
    }
  };

  const handleIncrement = () => {
    if (cartItem.quantite < cartItem.stock) {
      dispatch(increment(cartItem));
    }
  };

  return (
    <div className="cart-table-row">
      <div className="cart-table-col cart-designation-col">
        <div className="cart-product-info">
          <img
            loading="lazy"
            src={imgProd ? getImage(imgProd) : Empty}
            alt={cartItem?.produit?.nom}
            className="cart-product-image"
          />
          <div className="cart-product-details">
            <div className="cart-product-name">{cartItem?.produit?.nom}</div>
            <div className="cart-product-brand">
              Marque: {cartItem?.produit?.categorie?.nom || cartItem?.produit?.vendeur?.nom_de_la_boutique || "N/A"}
            </div>
          </div>
        </div>
      </div>
      <div className="cart-table-col cart-price-col">
        <span className="cart-price-value">{formatCurrency(cartItem?.prix, Vendeur?.devise)}</span>
      </div>
      <div className="cart-table-col cart-quantity-col">
        <div className="cart-quantity-selector">
          <button
            type="button"
            className="cart-quantity-btn cart-quantity-decrement"
            onClick={handleDecrement}
            disabled={cartItem?.quantite <= 1}
          >
            −
          </button>
          <span className="cart-quantity-value">{cartItem?.quantite}</span>
          <button
            type="button"
            className="cart-quantity-btn cart-quantity-increment"
            onClick={handleIncrement}
            disabled={cartItem?.quantite >= cartItem?.stock}
          >
            +
          </button>
        </div>
      </div>
      <div className="cart-table-col cart-total-col">
        <div className="cart-total-price">
          <span className="cart-total-value">
            {formatCurrency((cartItem?.prix * cartItem?.quantite), Vendeur?.devise)}
          </span>
          <div className="cart-item-actions">
            <button
              type="button"
              className="cart-action-btn cart-favorite-btn"
              onClick={handleToggleFavorite}
              title={isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"}
            >
              {isFavorite ? (
                <AiFillHeart style={{ color: "#f42d2d" }} />
              ) : (
                <AiOutlineHeart style={{ color: "#666" }} />
              )}
            </button>
            <button
              type="button"
              className="cart-action-btn cart-delete-btn"
              onClick={() => supprimerDuPanier(cartItem)}
              title="Supprimer"
            >
              <FaTrash style={{ color: "#f42d2d" }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


function PanierItemTable() {
  const { cartItems } = useAppSelector((state) => state.cart);

  return (
    <div className="cart-table-container">
      {cartItems?.length > 0 ? (
        <>
          <div className="cart-table-header">
            <div className="cart-table-col cart-designation-col">Désignation</div>
            <div className="cart-table-col cart-price-col">Prix</div>
            <div className="cart-table-col cart-quantity-col">Quantité</div>
            <div className="cart-table-col cart-total-col">Prix total</div>
          </div>
          <div className="cart-table-body">
            {cartItems.map((item, key) => (
              <CartItemCard key={item?.produit?.id || key} cartItem={item} />
            ))}
          </div>
        </>
      ) : (
        <AlertInfo message="Votre panier est vide" />
      )}
    </div>
  );
}

export default PanierItemTable;